import type { ReviewCard as ReviewCardType } from "./reviewTypes";
import ReviewCard from "./ReviewCard";

export type ReviewCardsColumnProps = {
  cards: ReviewCardType[];
  onEdit?: (card: ReviewCardType) => void;
  onDelete?: (card: ReviewCardType) => void;
  className?: string;
};

export function ReviewCardsColumn({
  cards,
  onEdit,
  onDelete,
  className,
}: ReviewCardsColumnProps) {
  return (
    <div className={`space-y-4 ${className ?? ""}`.trim()}>
      {cards.map((card) => (
        <ReviewCard
          key={card.id}
          card={card}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}

export default ReviewCardsColumn;
